"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getBlogs = void 0;

var _ActionTypes = _interopRequireDefault(require("ComposeUI/redux/ActionTypes"));

var _ContentGroups = _interopRequireDefault(require("ComposeUI/data/model/ContentGroups"));

var _constants = require("ComposeUI/lib/constants");

var getBlogs = function getBlogs(state) {
  return state.contentGroups;
};

exports.getBlogs = getBlogs;

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _ContentGroups.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_CONTENT_GROUPS_PENDING:
      return state.set('status', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_CONTENT_GROUPS_SUCCEEDED:
      return _ContentGroups.default.fromJS(action.data);

    case _ActionTypes.default.FETCH_CONTENT_GROUPS_FAILED:
      return state.set('status', _constants.RequestStatus.FAILED);

    default:
      return state;
  }
};

exports.default = _default;